import React from 'react';
import moment from 'moment';

const MagazineSurveyTable = ({
  magazineSurveyList,
  handleItemClick,
  handleDeleteMagazineSurvey
}) => {
  return (
    <div className="card">
      <div className="card-body">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h5 className="card-title fw-bold">Create Magazine Survey</h5>
          <button
            className="btn btn-primary"
            onClick={() => handleItemClick(null, "create-magazine-survey")}
          >
            Create Magazine Survey
          </button>
        </div>

        <div className="table-responsive">
          <table className="table table-striped table-hover">
            <thead className="table-light">
              <tr>
                <th scope="col">Survey</th>
                <th scope="col">Article Slug</th>
                <th scope="col">Created At</th>
                <th scope="col">Actions</th>
              </tr>
            </thead>
            <tbody>
              {magazineSurveyList.map((item) => (
                <tr key={item._id}>
                  <td>{item.surveyId.title}</td>
                  <td>
                    {Array.isArray(item.articleSlug) ? (
                      <div style={{maxHeight: '100px', overflowY: 'auto'}}>
                        {item.articleSlug.map((slug, index) => (
                          <div key={index} className="mb-1">
                            {slug}{index < item.articleSlug.length - 1 ? ',' : ''}
                          </div>
                        ))}
                      </div>
                    ) : (
                      item.articleSlug
                    )}
                  </td>
                  <td>{moment(item.createdAt).format("DD-MM-YYYY")}</td>
                  <td>
                    <button
                      className="btn btn-sm btn-warning me-2"
                      onClick={() => handleItemClick(item, "attach-magazine-survey")}
                    >
                      Attach
                    </button>
                    <button
                      className="btn btn-sm btn-danger"
                      onClick={() => handleDeleteMagazineSurvey(item._id)}
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default MagazineSurveyTable; 